export default [
    {
        name:"Data Table",
        icon:"",
        baseTPL:"<div class=\"pl-3 pr-3\">\n" +
            "    <table class=\"generic-styled-table\" style=\"width:100%\" v-if=\"data\">\n" +
            "        <thead>\n" +
            "        <tr>\n" +
            "            <th>Time</th>\n" +
            "            <th v-for=\"series in Object.keys(data)\" v-if=\"series!=='timestamp'\">{{series}}</th>\n" +
            "        </tr>\n" +
            "        </thead>\n" +
            "        <tbody>\n" +
            "        <tr v-for=\"(timestamp,index) in data.timestamp\">\n" +
            "            <td>{{timestamp|momentFormat('YYYY-MM-DD HH:mm:ss')}}</td>\n" +
            "            <td v-for=\"series in Object.keys(data)\" v-if=\"series!=='timestamp'\">{{data[series][index]}}</td>\n" +
            "        </tr>\n" +
            "        </tbody>\n" +
            "    </table>\n" +
            "</div>"
    },
    {
        name:"Latest Values Table",
        icon:"",
        baseTPL:"<div class=\"pl-3 pr-3\">\n" +
            "    <table class=\"generic-styled-table\" style=\"width:100%\" v-if=\"data\">\n" +
            "        <thead>\n" +
            "        <tr>\n" +
            "            <th></th>\n" +
            "            <th v-for=\"sensorName in Object.keys(latestValues).map(x=>x.split(' - ')[1]).filter((value, index, self) => self.indexOf(value) === index)\">{{sensorName}}</th>\n" +
            "        </tr>\n" +
            "        </thead>\n" +
            "        <tbody>\n" +
            "        <tr v-for=\"equipName in Object.keys(latestValues).map(x=>x.split(' - ')[0]).filter((value, index, self) => self.indexOf(value) === index)\">\n" +
            "            <td>{{equipName}}</td>\n" +
            "            <td v-for=\"sensorName in Object.keys(latestValues).map(x=>x.split(' - ')[1]).filter((value, index, self) => self.indexOf(value) === index)\">{{latestValues[equipName+' - '+sensorName]}}</td>\n" +
            "        </tr>\n" +
            "        </tbody>\n" +
            "    </table>\n" +
            "</div>"
    },{
        name:"Latest Values KPI",
        icon:"",
        baseTPL:"<div class=\"pl-3 pr-3\">\n" +
            "   <v-layout v-if=\"data\" row wrap>\n" +
            "       <v-flex class=\"lg3\" v-for=\"(item,index) in points\">\n" +
            "           <value-box :value=\"item.value\" :unit=\"item.unit!=='_' ? item.unit : ''\" :title=\"index\" has-comma></value-box>\n" +
            "       </v-flex>\n" +
            "   </v-layout>\n" +
            "</div>"
    },{
        name:"Title",
        icon:"",
        baseTPL:"<div class=\"pl-3 pr-3\">\n" +
            "    <h3 class=\"generic-styled-title\"><br>Title</h3>\n" +
            "    <hr class=\"generic-styled-bar\">\n" +
            "</div>"
    },
]